// ===== EMPLOYEES =====
export const sampleEmployees = [
  {
    id: 'emp1',
    firstName: 'Ashanti',
    lastName: '',
    email: 'ashanti@twosisterscleaningco.com',
    phone: '(434) 555-0101',
    role: 'employee',
    hourlyRate: 17.00,
    payRates: [
      { label: 'Cleaner', rate: 17.00 },
      { label: 'Driver', rate: 17.50 }
    ],
    status: 'active',
    hireDate: '2023-03-15',
    skills: ['residential', 'deep_clean'],
    avatar: 'A',
    teamId: 'team-a',
    availability: {
      monday: { available: true, start: '08:00', end: '17:00' },
      tuesday: { available: true, start: '08:00', end: '17:00' },
      wednesday: { available: true, start: '08:00', end: '17:00' },
      thursday: { available: true, start: '08:00', end: '17:00' },
      friday: { available: true, start: '08:00', end: '17:00' },
      saturday: { available: false, start: '08:00', end: '17:00' },
      sunday: { available: false, start: '08:00', end: '17:00' }
    },
    defaultShift: {
      startTime: '08:00',
      endTime: '16:00'
    }
  },
  {
    id: 'emp2',
    firstName: 'Brandi',
    lastName: '',
    email: 'brandi@twosisterscleaningco.com',
    phone: '(434) 555-0102',
    role: 'employee',
    hourlyRate: 18.00,
    status: 'active',
    hireDate: '2023-06-01',
    skills: ['residential', 'str_turnover'],
    avatar: 'B',
    teamId: 'team-a',
    availability: {
      monday: { available: true, start: '08:00', end: '17:00' },
      tuesday: { available: true, start: '08:00', end: '17:00' },
      wednesday: { available: true, start: '08:00', end: '17:00' },
      thursday: { available: true, start: '08:00', end: '17:00' },
      friday: { available: true, start: '08:00', end: '17:00' },
      saturday: { available: false, start: '08:00', end: '17:00' },
      sunday: { available: false, start: '08:00', end: '17:00' }
    },
    defaultShift: {
      startTime: '08:00',
      endTime: '16:00'
    }
  },
  {
    id: 'emp3',
    firstName: 'Elaine',
    lastName: '',
    email: 'elaine@twosisterscleaningco.com',
    phone: '(434) 555-0103',
    role: 'manager',
    hourlyRate: 22.00,
    status: 'active',
    hireDate: '2023-01-10',
    skills: ['residential', 'commercial', 'deep_clean', 'organizing'],
    avatar: 'E',
    teamId: 'team-b',
    availability: {
      monday: { available: true, start: '08:00', end: '18:00' },
      tuesday: { available: true, start: '08:00', end: '18:00' },
      wednesday: { available: true, start: '08:00', end: '18:00' },
      thursday: { available: true, start: '08:00', end: '18:00' },
      friday: { available: true, start: '08:00', end: '18:00' },
      saturday: { available: false, start: '08:00', end: '17:00' },
      sunday: { available: false, start: '08:00', end: '17:00' }
    },
    defaultShift: {
      startTime: '08:00',
      endTime: '17:00'
    }
  },
  {
    id: 'emp4',
    firstName: 'Sam',
    lastName: '',
    email: 'sam@twosisterscleaningco.com',
    phone: '(434) 555-0104',
    role: 'manager',
    hourlyRate: 22.00,
    status: 'active',
    hireDate: '2023-09-15',
    skills: ['residential', 'commercial', 'deep_clean'],
    avatar: 'S',
    teamId: 'team-b',
    availability: {
      monday: { available: true, start: '09:00', end: '17:00' },
      tuesday: { available: true, start: '09:00', end: '17:00' },
      wednesday: { available: true, start: '09:00', end: '17:00' },
      thursday: { available: true, start: '09:00', end: '17:00' },
      friday: { available: true, start: '09:00', end: '14:00' },
      saturday: { available: false, start: '08:00', end: '17:00' },
      sunday: { available: false, start: '08:00', end: '17:00' }
    },
    defaultShift: {
      startTime: '09:00',
      endTime: '17:00'
    }
  }
];

// ===== CLIENTS =====
export const sampleClients = [
  {
    id: 'client1',
    firstName: 'Emily',
    lastName: 'Patterson',
    email: 'emily.patterson@email.com',
    phone: '(434) 555-1001',
    clientType: 'residential',
    status: 'active',
    frequency: 'weekly',
    preferredDay: 'Monday',
    communicationPref: ['text', 'email'],
    textConsent: true,
    notes: 'Prefers eco-friendly products. Has a golden retriever named Max.',
    autoInvoice: true,
    paymentTerms: 'due_on_receipt',
    createdAt: '2023-06-15'
  },
  {
    id: 'client2',
    firstName: 'Michael',
    lastName: 'Thompson',
    email: 'mthompson@blueridgepm.com',
    phone: '(434) 555-1002',
    clientType: 'property_manager',
    status: 'active',
    frequency: 'on_demand',
    communicationPref: ['email'],
    textConsent: true,
    notes: 'Property manager for Blue Ridge Rentals. Manages 12 STR properties.',
    autoInvoice: true,
    paymentTerms: 'net_30',
    createdAt: '2023-03-20'
  },
  {
    id: 'client3',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.j@email.com',
    phone: '(434) 555-1003',
    clientType: 'residential',
    status: 'active',
    frequency: 'biweekly',
    preferredDay: 'Thursday',
    communicationPref: ['text'],
    textConsent: true,
    notes: 'Two cats. Please keep doors closed.',
    autoInvoice: true,
    paymentTerms: 'due_on_receipt',
    createdAt: '2023-08-10'
  },
  {
    id: 'client4',
    firstName: 'Robert',
    lastName: 'Chen',
    email: 'rchen@downtownoffice.com',
    phone: '(434) 555-1004',
    clientType: 'commercial',
    status: 'active',
    frequency: 'weekly',
    preferredDay: 'Friday',
    communicationPref: ['email'],
    textConsent: false,
    notes: 'Downtown law office. After hours cleaning only (after 6pm).',
    autoInvoice: false,
    paymentTerms: 'net_15',
    createdAt: '2023-05-01'
  },
  {
    id: 'client5',
    firstName: 'Jennifer',
    lastName: 'Williams',
    email: 'jwilliams@email.com',
    phone: '(434) 555-1005',
    clientType: 'residential',
    status: 'active',
    frequency: 'monthly',
    preferredDay: 'Wednesday',
    communicationPref: ['text', 'email'],
    textConsent: true,
    notes: 'Deep clean only. Large home with 5 bedrooms.',
    autoInvoice: true,
    paymentTerms: 'net_7',
    createdAt: '2024-01-05'
  },
  {
    id: 'client6',
    firstName: 'David',
    lastName: 'Miller',
    email: 'dmiller@email.com',
    phone: '(434) 555-1006',
    clientType: 'residential',
    status: 'inactive',
    frequency: 'biweekly',
    communicationPref: ['text'],
    textConsent: true,
    notes: 'On hold - traveling for 3 months.',
    autoInvoice: true,
    paymentTerms: 'due_on_receipt',
    createdAt: '2023-07-22'
  }
];

// ===== PROPERTIES =====
export const sampleProperties = [
  {
    id: 'prop1',
    clientId: 'client1',
    addressLine1: '123 Oak Street',
    city: 'Charlottesville',
    state: 'VA',
    zip: '22901',
    sqft: 2200,
    bedrooms: 3,
    bathrooms: 2.5,
    pets: 'Dog (Max)',
    accessInfo: 'Lockbox code: 4521. Located on front porch.',
    isPrimary: true,
    coordinates: { lat: 38.0293, lng: -78.4767 }
  },
  {
    id: 'prop2',
    clientId: 'client2',
    addressLine1: '456 Mountain View Dr',
    city: 'Charlottesville',
    state: 'VA',
    zip: '22903',
    sqft: 1400,
    bedrooms: 2,
    bathrooms: 1,
    accessInfo: 'Smart lock - code sent day of cleaning',
    isPrimary: true,
    coordinates: { lat: 38.0350, lng: -78.5000 }
  },
  {
    id: 'prop3',
    clientId: 'client2',
    addressLine1: '789 University Circle',
    city: 'Charlottesville',
    state: 'VA',
    zip: '22904',
    sqft: 1800,
    bedrooms: 3,
    bathrooms: 2,
    accessInfo: 'Key under mat by back door',
    isPrimary: false,
    coordinates: { lat: 38.0400, lng: -78.5100 }
  },
  {
    id: 'prop4',
    clientId: 'client3',
    addressLine1: '321 Maple Lane',
    city: 'Crozet',
    state: 'VA',
    zip: '22932',
    sqft: 1600,
    bedrooms: 3,
    bathrooms: 2,
    pets: '2 cats',
    accessInfo: 'Garage code: 1234. Enter through garage.',
    isPrimary: true,
    coordinates: { lat: 38.0700, lng: -78.7000 }
  },
  {
    id: 'prop5',
    clientId: 'client4',
    addressLine1: '100 Main Street, Suite 200',
    city: 'Charlottesville',
    state: 'VA',
    zip: '22902',
    sqft: 3500,
    accessInfo: 'Building manager will provide access. Call 30 min before arrival.',
    isPrimary: true,
    coordinates: { lat: 38.0300, lng: -78.4800 }
  },
  {
    id: 'prop6',
    clientId: 'client5',
    addressLine1: '555 Ivy Road',
    city: 'Charlottesville',
    state: 'VA',
    zip: '22903',
    sqft: 4200,
    bedrooms: 5,
    bathrooms: 4,
    pets: 'None',
    accessInfo: 'Ring doorbell. Homeowner works from home.',
    isPrimary: true,
    coordinates: { lat: 38.0250, lng: -78.5200 }
  }
];

// ===== LOOKUP DATA =====
export const clientTypes = {
  residential: { label: 'Residential', color: 'var(--sage)' },
  property_manager: { label: 'Property Manager', color: 'var(--gold)' },
  commercial: { label: 'Commercial', color: 'var(--teal)' }
};

export const employeeRoles = {
  admin: { label: 'Admin', color: 'var(--navy)' },
  manager: { label: 'Manager', color: 'var(--gold)' },
  lead: { label: 'Team Lead', color: 'var(--sage)' },
  employee: { label: 'Cleaner', color: 'var(--teal)' }
};

export const frequencyOptions = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'biweekly', label: 'Every 2 Weeks' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'on_demand', label: 'On Demand' }
];

export const paymentTermsOptions = [
  { value: 'due_on_receipt', label: 'Due Upon Receipt', days: 0 },
  { value: 'net_7', label: 'Net 7', days: 7 },
  { value: 'net_15', label: 'Net 15', days: 15 },
  { value: 'net_30', label: 'Net 30', days: 30 },
  { value: 'net_60', label: 'Net 60', days: 60 }
];

export const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
